<span class="duna-validation-badge" 
      [ngClass]="getCssClasses()"
      [matTooltip]="getValidationTooltip()">
  <mat-icon class="validation-icon">{{ getValidationIcon() }}</mat-icon>
  {{ getValidationText() }}
</span> 